import React from 'react';
import { Modal, DatePicker, message } from 'antd';
import moment from 'moment';

import SharedTools from '../../lib/SharedTools';
import DataService from '../../lib/DataService';
const DATEFORMAT = 'YYYY-MM-DD'

export default class SetCalendarDateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startValue: null,
      endValue: null,
      endOpen: false,
      loading: false
    }

  }

  componentDidMount() {
  }

  componentWillReceiveProps(newProps) {
  }

  disabledStartDate = (startValue) => {
    const endValue = this.state.endValue;
    if (!startValue || !endValue) {
      return false;
    }
    return moment(startValue, DATEFORMAT).valueOf() > moment(endValue, DATEFORMAT).valueOf();
  }

  disabledEndDate = (endValue) => {
    const startValue = this.state.startValue;
    if (!endValue || !startValue) {
      return false;
    }
    return moment(endValue, DATEFORMAT).valueOf() <= moment(startValue, DATEFORMAT).valueOf();
  }

  onChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  onStartChange = (value, dateString) => {
    this.onChange('startValue', dateString);
  }

  onEndChange = (value, dateString) => {
    this.onChange('endValue', dateString);
  }

  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  }

  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  }

  handleOk = () => {
    if (this.state.startValue && this.state.endValue) {
      this.setState({
        loading: true
      })
      let data = {
        school_id: this.props.schoolId,
        semester: this.props.semester,
        start_year: new Date(this.state.startValue).getFullYear(),
        start_month: new Date(this.state.startValue).getMonth() + 1,
        start_day: new Date(this.state.startValue).getDate(),
        end_year: new Date(this.state.endValue).getFullYear(),
        end_month: new Date(this.state.endValue).getMonth() + 1,
        end_day: new Date(this.state.endValue).getDate(),
      }
      DataService.createCalendarDate(data).then((res) => {
        this.props.callBackCalendarDate(this.state.startValue, this.state.endValue)
        this.props.closeModal();
        this.setState({
          loading: false
        })
      }).catch((error) => {
        if (error && error.errorMessage.errors[0].code == 51) {
          message.error('当前学期已设置过日历，请联系嘟嘟助手更改日历时间');
        } else {
          message.error('学校日历设置失败');
        }
        this.setState({
          loading: false
        })
      });
    } else {
      message.info('请选择正确的日历时间')
    }

  }

  handleCancel = () => {
    this.props.closeModal();
  }

  render() {
    const { startValue, endValue, endOpen } = this.state;
    return (
      <Modal
        title="设置学校日历日期"
        visible={this.props.showSetCalendarDate}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        wrapClassName="set-calendar-date-modal"
        maskClosable={false}
      >
        <div className="date-picker-container">
          起始时间：
          <DatePicker
            disabledDate={this.disabledStartDate}
            format="YYYY-MM-DD"
            value={startValue ? moment(startValue, DATEFORMAT) : startValue}
            placeholder="Start"
            onChange={this.onStartChange}
            onOpenChange={this.handleStartOpenChange}
            allowClear={false}
          />
        </div>
        <div>
          结束时间：
          <DatePicker
            disabledDate={this.disabledEndDate}
            format="YYYY-MM-DD"
            value={endValue ? moment(endValue, DATEFORMAT) : endValue}
            placeholder="End"
            onChange={this.onEndChange}
            open={endOpen}
            onOpenChange={this.handleEndOpenChange}
            allowClear={false}
          />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/SetCalendarDateModal.jsx